import { ICourse, ICourseStatus, ICourseType } from "utils/types";

export type ICourseTypeMenuOptionID = ICourseType | "all"
export const courseTypeOptions:{
    value: ICourseTypeMenuOptionID, label: string;
}[] = [
    { label: "All", value: "all" },
    { label: "Premium", value: "premium" },
    { label: "Free", value: "free" },
  ];

export type ICourseStatusOptionID = ICourseStatus | "all"
export const courseStatusOptions:{
    value: ICourseStatusOptionID; label: string;
}[] = [
    { label: "All", value: "all" },
    { label: "Active", value: "active" },
    { label: "InActive", value: "inactive" },
  ];

export const lastDateModifiedOptions = [
    { label: "All time", value: "all" },
    { label: "Last 24 hours", value: "24hours" },
    { label: "Last 7 days", value: "7days" },
    { label: "Last 30 days", value: "30days" },
    { label: "Last 90 days", value: "90days" },
  ];

export const searchOptions = [
    { label: "Introduction to React", value: "intro_react" },
    { label: "Advanced JavaScript", value: "adv_js" },
    { label: "UI/UX Design Basics", value: "uiux_basics" },
  ];


  // Remove 
  const allCourses = {
    recommended: [
      {
        id: "usmle",
        title: "USMLE United States Medical Licensing Examination",
        description: "Available past questions",
        imageUrl: "/assets/course.png",
        duration: "2020",
        tag: "FREE",
      },
      {
        id: "hccp",
        title: "HCCP Medical College Selection Test",
        description: "Available past questions",
        imageUrl: "/assets/course2.png",
        duration: "2020",
        tag: "PREMIUM",
      },
      {
        id: "pl48",
        title: "PL48 Professional and Linguistic Assessments Board",
        description: "Available past questions",
        imageUrl: "/assets/course3.png",
        duration: "2020",
        tag: "PREMIUM",
      },
      {
        id: "neet-pg",
        title: "NEET-PG National Eligibility cum Entrance Test",
        description: "Available past questions",
        imageUrl: "/assets/course4.png",
        duration: "2021",
        tag: "PREMIUM",
      },
    ],
    specialized: [
      {
        id: "mscp",
        title: "MSCP (Membership of the Royal Colleges of Physicians)",
        description: "Available past questions",
        imageUrl: "/assets/course5.png",
        duration: "2025",
        tag: "PREMIUM",
      },
      {
        id: "nbme",
        title: "NBME (National Board of Medical Examiners)",
        description: "Available past questions",
        imageUrl: "/assets/course6.png",
        duration: "2025",
        tag: "PREMIUM",
      },
      {
        id: "complex-usa",
        title:
          "COMPLEX-USA Comprehensive Osteopathic Medical Licensing Examination",
        description: "Available past questions",
        imageUrl: "/assets/course7.png",
        duration: "2024",
        tag: "FREE",
      },
    ],
  };